import { render } from "./FilterItem.vue?vue&type=template&id=5a50e3d2&scoped=true"
import script from "./FilterItem.vue?vue&type=script&lang=js"
export * from "./FilterItem.vue?vue&type=script&lang=js"

import "./FilterItem.vue?vue&type=style&index=0&id=5a50e3d2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a50e3d2"]])

export default __exports__